export default __webpack_public_path__ + "static/media/minimize-icon.b8c73833.svg";